export const HOME_SECTIONS = ["#about", "#how-it-works", "#products"]
